<template>
  <div :class="customClass + ' v2-view-recap-container'">
    <template v-if="isBusy || isBusyResend">
      <div class="table-loader">
        <Preloader />
      </div>
    </template>
    <template v-else-if="currentStep === 5">
      <div class="v2-success-view">
        <div class="success-header">
          <div class="success-icon-badge">
            <font-awesome-icon icon="check" />
          </div>
          <h1>Merci pour votre souscription !</h1>
          <p>Votre contrat de garantie auto a été validé et enregistré.</p>
        </div>

        <div class="success-main-content">
          <div class="document-download-card">
            <div class="doc-info">
              <div class="doc-icon">
                <font-awesome-icon icon="file-pdf" />
              </div>
              <div class="doc-details">
                <h3>Certificat de Garantie</h3>
                <span>Format PDF • Prêt à imprimer</span>
              </div>
            </div>
            <button type="button" class="btn-download-pdf" @click="showPdf">
              <font-awesome-icon icon="eye" />
              Aperçu
            </button>
          </div>

          <div class="success-actions">
            <button type="button" class="btn-link-action" @click="restartFresh">
              <font-awesome-icon icon="plus-circle" />
              Souscrire à une autre garantie
            </button>
            <router-link to="/devis" class="btn-link-action secondary">
              <font-awesome-icon icon="th-list" />
              Voir mes devis
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Header Section -->
      <header class="v2-view-header">
        <div class="header-left">
          <!-- <router-link to="/devis" class="v2-back-link" v-if="showRetourButton">
            <font-awesome-icon icon="arrow-circle-left" />
            Retour
          </router-link> -->
          <h1>Devis en ligne</h1>
        </div>
        <div class="header-right" v-if="!currentStep">
          <router-link :to="'/garantie-auto-v2/' + $route.params.id" class="v2-modify-btn">
            <font-awesome-icon icon="pencil-alt" />
            Modifier
          </router-link>
        </div>
      </header>

      <div class="v2-view-grid">
        <!-- Main Column -->
        <main class="v2-main-col">
          <!-- <div class="v2-title-header-row">
            <div class="v2-view-section-title text-uppercase">
              RAPPEL DES INFORMATIONS COMMUNIQUÉES
            </div>
          </div> -->

          <!-- Warnings -->
          <div class="alert alert-warning mb-2" v-if="numberOfDuplicates > 0">
            <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
            Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro d’immatriculation.
          </div>

          <div class="v2-view-accordion-stack">
            <!-- Client Info Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': ownerExpanded }"
              v-if="insurance && insurance.client">
              <header class="accordion-header" @click="ownerExpanded = !ownerExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="user-circle" />
                  <h2>Vos coordonnées</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="ownerExpanded">
                <div class="card-body grid-adaptive">
                  <div class="info-item" v-if="+insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                    <label>Civilité :</label>
                    <span class="info-val">{{ parseCivility(insurance.client.civility) }}</span>
                  </div>
                  <div class="info-item" v-else>
                    <label>Société :</label>
                    <span class="info-val">{{ insurance.client.name_of_signatory }}</span>
                  </div>

                  <div class="info-item">
                    <label>
                      {{ +insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID ? 'Nom :' : 'Nom du signataire : '
                      }}
                    </label>
                    <span class="info-val">{{ insurance.client.last_name }}</span>
                  </div>

                  <div class="info-item" v-if="insurance.client.first_name">
                    <label>
                      {{
                        insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID ? 'Prénom :' : 'Prénom du signataire : '
                      }}
                    </label>
                    <span class="info-val">{{ insurance.client.first_name }}</span>
                  </div>

                  <div class="info-item">
                    <label>Email :</label>
                    <span class="info-val">{{ insurance.client.email }}</span>
                  </div>

                  <div class="info-item">
                    <label>Téléphone :</label>
                    <span class="info-val">{{ insurance.client.tel }}</span>
                  </div>

                  <div class="info-item">
                    <label>Adresse :</label>
                    <span class="info-val text-capitalize">{{ insurance.client.address }}, {{ insurance.client.zip }} {{
                      insurance.client.city }}</span>
                  </div>

                  <div class="info-item"
                    v-if="insurance.client && insurance.client.birthday && insurance.client.birthday != '1900-01-01 00:00:00'">
                    <label>Date de naissance :</label>
                    <span class="info-val">{{ parseBirthDate(insurance.client.birthday) }}</span>
                  </div>


                </div>
              </div>
            </section>

            <!-- Vehicle Info Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': vehicleExpanded }"
              v-if="insurance.details">
              <header class="accordion-header" @click="vehicleExpanded = !vehicleExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="car" />
                  <h2>Votre Véhicule</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="vehicleExpanded">
                <div class="card-body grid-adaptive">
                  <div class="info-item">
                    <label>Immatriculation :</label>
                    <span class="info-val plate-style">{{ insurance.details.registration }}</span>
                  </div>

                  <div class="info-item">
                    <label>Garantie :</label>
                    <span class="info-val">{{ parseValue(insurance.details.garantie, INSURANCE_AUTO) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Durée :</label>
                    <span class="info-val">{{ parseValue(insurance.details.duration, AUTO_DURATION) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Marque/Modèle :</label>
                    <span class="info-val">{{ insurance.details.car_brand }} / {{ insurance.details.modele_porteur
                    }}</span>
                  </div>

                  <div class="info-item">
                    <label>Type de véhicule :</label>
                    <span class="info-val">{{ parseValue(insurance.details.type_vehicle, AUTO_TYPE) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Carburant :</label>
                    <span class="info-val">{{ parseValue(insurance.details.car_fuel, AUTO_ENGINE) }}</span>
                  </div>

                  <div class="info-item" v-if="+insurance.details.car_fuel !== AUTO_ENGINE.ELECTRIC.ID">
                    <label>Cylindrée :</label>
                    <span class="info-val">{{ parseTypeCylinder(insurance.details.cylinder) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Puissance fiscale :</label>
                    <span class="info-val">{{ insurance.details.fiscal_power }}</span>
                  </div>

                  <div class="info-item" v-if="+insurance.details.car_fuel === AUTO_ENGINE.ELECTRIC.ID">
                    <label>Puissance en Kw :</label>
                    <span class="info-val">{{ parseValue(insurance.details.power_kw, AUTO_POWER_KW) }} Kw</span>
                  </div>

                  <div class="info-item">
                    <label>Date de 1ère mise en circulation :</label>
                    <span class="info-val">{{ parseCirculationDate(insurance.details) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Date d'effet :</label>
                    <span class="info-val">{{ parseEffectiveDate(insurance.details) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Kilométrage :</label>
                    <span class="info-val">{{ insurance.details.km_real || '-' }}</span>
                  </div>

                  <div class="info-item">
                    <label>Numéro de série :</label>
                    <span class="info-val">{{ insurance.details.serial_number }}</span>
                  </div>
                </div>
              </div>
            </section>

            <!-- Info & Disclaimer Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': infoExpanded }">
              <header class="accordion-header" @click="infoExpanded = !infoExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="info-circle" />
                  <h2>Durée et Prise d'effet</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="infoExpanded">
                <div class="card-body">
                  <div class="v2-warranty-info-text">
                    <div class="v2-selected-plan-banner" v-if="insurance.details">
                      Vous avez choisi la panne mécanique
                      <strong>{{ parseValue(insurance.details.garantie, INSURANCE_AUTO) }}</strong>
                      pour une durée de
                      <strong>{{ parseValue(insurance.details.duration, AUTO_DURATION) }}</strong>
                    </div>
                    <p>
                      Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie par
                      <strong>{{ mechanicCode != '705223' ? 'Dynassurances' : 'le garant' }}</strong>,
                      la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                      particuli&egrave;res du contrat
                      et prendra fin automatiquement &agrave; 24 heures jour pour jour selon les dates indiqu&eacute;es
                      sur
                      le certificat de garantie.
                    </p>
                    <p class="font-weight-bold mt-3">Cependant la garantie prendra fin de plein droit avant son terme :
                    </p>
                    <ul class="v2-feature-list">
                      <li>
                        <font-awesome-icon icon="caret-right" />
                        <span>en cas de destruction du v&eacute;hicule, quelle qu'en soit la cause, par
                          r&eacute;siliation,</span>
                      </li>
                      <li>
                        <font-awesome-icon icon="caret-right" />
                        <span>en cas de d&eacute;ch&eacute;ance du b&eacute;n&eacute;ficiaire de la garantie pour non
                          respect des prescriptions du constructeur sur l'usage pour lequel le v&eacute;hicule est
                          con&ccedil;u.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <!-- Coverage Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': guaranteesExpanded }">
              <header class="accordion-header" @click="guaranteesExpanded = !guaranteesExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="shield-alt" />
                  <h2>Garanties accordées</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="guaranteesExpanded">
                <div class="card-body">
                  <div class="v2-plan-accordion">
                    <div class="v2-accordion-item is-expanded">
                      <div class="v2-accordion-content">
                        <Accordes :insurance="insurance" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>


          </div>
        </main>

        <!-- Sidebar Actions -->
        <aside class="v2-sticky-sidebar">
          <div class="v2-price-card">
            <div class="price-section">
              <span class="price-label">Prime totale T.T.C. (&euro;) *</span>
              <div class="grand-price" v-if="getPrice">
                {{ getPrice.split(' ')[0] }} <small>€</small>
              </div>
              <!-- <div class="alert alert-danger p-2 fs-08" v-else>
                Les critères du véhicule ne permettent pas de souscrire à la garantie choisie.
              </div> -->
              <p class="price-note" v-if="getPrice">
                * Frais de dossier et taxe attentats inclus.
              </p>
            </div>

            <div class="v2-actions-stack">
              <!-- Subscribe Button -->
              <button v-if="getGarantiePrice && !mechanicClientPayment" class="btn-primary-outline"
                @click.prevent="checkSubscription(insurance, changeStep)">
                <font-awesome-icon icon="rocket" />
                Souscrire à la garantie
              </button>

              <!-- Send Email Button -->
              <button v-if="mechanicClientPayment && getPrice" class="btn-success-outline"
                @click.prevent="checkSubscription(insurance, resendEmail)">
                <font-awesome-icon icon="envelope" />
                Envoyer le devis par e-mail
              </button>

              <!-- Save Button -->
              <button v-if="mechanicCode != '705223'" class="v2-btn-block outline" @click.prevent="getFrontPdf()">
                <font-awesome-icon icon="download" />
                Sauvegarder sur mon ordinateur
              </button>
              <button v-else class="v2-btn-block outline" @click.prevent="getFrontPdfWL()">
                <font-awesome-icon icon="download" />
                Sauvegarder sur mon ordinateur
              </button>

              <!-- Print Button -->
              <button type="button" class="v2-btn-block outline"
                @click.prevent="mechanicCode != '705223' ? getFrontPdf(true) : getFrontPdfWL(true)">
                <font-awesome-icon icon="print" />
                Imprimer le détail de la garantie
              </button>

              <hr class="my-2">

              <!-- Close Button -->
              <router-link v-if="!showRetourButton" :to="'/'"
                class="btn-secondary-outline text-decoration-none">Fermer</router-link>
              <router-link v-else :to="'/devis'" class="btn-secondary-outline text-decoration-none">Fermer</router-link>
            </div>

            <div class="sidebar-contact-info mt-4 pt-3 border-top">
              <span>CONTACTER OU SOUSCRIRE :</span>
              <p class="mb-0 fs-11"><a href="tel:+33148895757">01 48 89 57 57</a></p>
            </div>
          </div>


          <!-- Extra Warning/Info if ineligible -->
          <div class="alert alert-danger fs-08" v-if="!getPrice">
            <strong>Inéligibilité :</strong> Les critères du véhicule ne permettent pas de souscrire.
            Pour une dérogation, contactez <a href="mailto:servicetechnique@dynassurances.fr"
              class="text-danger underline">servicetechnique@dynassurances.fr</a>
          </div>
        </aside>
      </div>

      <!-- PDF Page Break Logic (for printing) -->
      <template v-if="printManyPages">
        <div class="print-page-break"></div>
      </template>

      <PdfModal v-show="pdfModal" @close="closePdfModal" :quote="this.insurance" :is-shown="pdfModal" />
    </template>
  </div>
</template>

<script>
import PdfModal from "@/components/Garantie/PdfModal";
import Preloader from "@/components/Preloader";
import garantieFieldsList from "../../../mixins/garantieFieldsLists";
import Accordes from "../GarantiesAccordesAuto";
import {
  AUTO_DURATION,
  AUTO_ENGINE,
  AUTO_POWER_KW,
  AUTO_TYPE,
  INSURANCE_AUTO
} from "../../../constants/insuranceAuto";
import insuranceMethods from "../../../mixins/insuranceMethods";
import { CLIENT_CIVILITY } from "../../../constants/client";
import pdfPreviewMixin from '../../../mixins/pdfPreviewMixin';

export default {
  name: "GarantieAutoView",
  components: {
    PdfModal,
    Preloader,
    Accordes
    // GarantieSubscriptionModal
  },
  mixins: [garantieFieldsList, insuranceMethods, pdfPreviewMixin],
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    insuranceData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isBusy: false,
      isBusyResend: false,
      pdfModal: false,
      subscriptionModal: false,
      selectedInsurance: 0,
      insurance: {
        address: null,
        category: null,
        city: null,
        civility: null,
        email: null,
        first_name: null,
        last_name: null,
        tel: null,
        zip: null
      },
      showRetourButton: false,
      AUTO_ENGINE,
      AUTO_POWER_KW,
      AUTO_TYPE,
      INSURANCE_AUTO,
      AUTO_DURATION,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
      ownerExpanded: true,
      vehicleExpanded: true,
      infoExpanded: false,
      guaranteesExpanded: false,
      hashModal: (+new Date()).toString(36)
    };
  },
  computed: {
    printManyPages() {
      return (
        this.insurance &&
        this.insurance.details &&
        +this.insurance.details.garantie != 3
      );
    },
    getDownloadLinkConfirmationPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/confirmation-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLink() {
      if (this.insurance.id) {
        // alert('getDownloadLink 592');
        return this.getApiAuthUrl("garantie/generate-pdf/" + this.insurance.id);
        // alert('after getDownloadLink 594');
      }

      return "";
    },
    getDownloadLinkWL() {
      if (this.insurance.id) {
        // alert('getDownloadLink 592');
        return this.getApiAuthUrl(
          "garantie/generate-pdfWL/" + this.insurance.id
        );
        // alert('after getDownloadLink 594');
      }

      return "";
    },
    getDownloadLinkCopyPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkCopyPdfWL() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdfWL/" + this.insurance.id
        );

      return "";
    },
    getPrice() {
      return this.insurance.price
        ? this.roundEURWithoutSymbol(this.insurance.price).replace(".", ",") +
        " €"
        : "";
    },
    getGarantiePrice() {
      return this.insurance.price && +this.insurance.price > 0;
    },
    mechanicCode() {
      let code =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.code
          : null;
      return code ? code : "";
    },
    mechanicClientPayment() {
      let client_payment =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.client_payment
          : null;
      return client_payment ? client_payment : "";
    },
  },
  methods: {
    changeStep(step = 5) {
      if (!this.insurance || !this.insurance.details || !this.insurance.details.serial_number) {
        this.showErrorNotificationText(
            "Le numéro de série (VIN) du véhicule est manquant.<br>" +
            "Veuillez retourner à l'étape 1, ouvrir le popup <strong>Modifier le véhicule</strong> " +
            "et saisir le Numéro de série (VIN) avant de souscrire à la garantie.",
            null
        );
        return;
      }
      this.mechanicCode != '705223' ? this.getPDF() : this.getPDFWL()
    },
    showPdf() {
      this.show_pdf(this.insurance.id);
      // this.restartFresh();
    },
    restartFresh() {
      // Force a full reload to the base creation URL to ensure all state (parents, etc.) is perfectly clean
      window.location.href = '/garantie-auto-v2';
    },


    confirmSubscription() {
      this.$confirm({
        message:
          "Les critères du véhicule ne permettent pas de souscrire à la garantie choisie. Etes-vous sûr de vouloir envoyer un devis sans prix à votre client ?",
        button: {
          no: "Non",
          yes: "Oui"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.checkSubscription(this.insurance, this.resendEmail)
          }
        }
      });
    },
    openSubscriptionModal(insurance) {
      // alert('openSubscriptionModal');
      // alert(insurance);
      this.selectedInsurance = insurance;

      let message =
        "Vous avez opté pour un règlement direct de la garantie ci-dessus par votre client. Etes-vous sûr de vouloir souscrire cette garantie et la régler pour votre client ?";
      // alert(message);
      this.$eventBus.$emit("confirm-modal-open", {
        message,
        callback: this.subscribeInsurance,
        hash: this.hashModal
      });
    },
    subscribeInsurance() {
      // alert('subscribeInsurance');
      // if (this.selectedComment > 0) {
      //   this.isBusy = true;
      //   let url = 'comments/' + this.selectedComment;
      //   this.apiDelete(url)
      //     .then(response => {
      //       this.isBusy = false;
      //       this.showSuccessNotification("comment_has_been_deleted");
      //
      //       let foundedIndex = this.comments.findIndex(item => +item.id == +this.selectedComment);
      //
      //       if (foundedIndex >= 0) {
      //         this.comments.splice(foundedIndex, 1);
      //       }
      //
      //       this.cancelDeleteComment();
      //     })
      //     .catch(error => {
      //       this.isBusy = false;
      //       this.showErrorNotification(error);
      //     })
      // } else {
      //   this.showErrorNotification("Comment not selected");
      // }
    },
    getConfirmationPDF() {
      this.refreshTokenForce()
        .then(response => {
          if (this.getDownloadLinkConfirmationPdf) {
            window.location = this.getDownloadLinkConfirmationPdf;
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch(error => {
          this.showErrorNotification(error);
        });
    },
    closePdfModal() {
      this.pdfModal = false;
    },
    closeSubscriptionModal() {
      this.subscriptionModal = false;
    },
    getPDF() {
      // alert('getPDF');
      if (this.checkEffectiveDate(this.insurance)) {
        this.refreshTokenForce()
          .then(response => {
            this.isBusy = true;
            if (this.getDownloadLink) {
              // alert('getDownloadLink 631');
              fetch(this.getDownloadLink, {
                method: 'GET',
                credentials: 'include'
              })
                .then(() => {
                  console.log('PDF generation triggered');
                })
                .catch(err => {
                  console.error('Error triggering PDF', err);
                }).finally(() => {
                  this.isBusy = false;
                  this.$emit('change-step', 5);
                });
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch(error => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getPDFWL() {
      // alert('getPDF');
      if (this.checkEffectiveDate(this.insurance)) {
        this.refreshTokenForce()
          .then(response => {
            this.isBusy = true;
            if (this.getDownloadLink) {
              // alert('getDownloadLink 631');
              fetch(this.getDownloadLink, {
                method: 'GET',
                credentials: 'include'
              })
                .then(() => {
                  console.log('PDF generation triggered');
                })
                .catch(err => {
                  console.error('Error triggering PDF', err);
                }).finally(() => {
                  this.isBusy = false;
                  this.$emit('change-step', 5);
                });
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch(error => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    printInsurance() {
      this.ownerExpanded = true;
      this.vehicleExpanded = true;
      this.infoExpanded = true;
      this.guaranteesExpanded = true;

      setTimeout(() => {
        window.print();
      }, 300); // allow UI to update
    },
    resendEmail() {
      console.log('this.insurance.id', this.insurance.id);
      this.isBusyResend = true;
      let url = "garantie/send-quote-email/" + this.insurance.id;

      this.apiPost(url, {})
        .then(response => {
          this.isBusyResend = false;
          if (response.data.quote && response.data.status == "success") {
            this.showSuccessNotification(response.data.message, "");
            this.$emit('change-step', 6);
          }
        })
        .catch(error => {
          this.isBusyResend = false;
          this.showErrorNotification(error);
        });
    },
    getQuoteInfo(id) {
      if (!id) {
        id = this.$route.params.id;
      }
      if (!id || id === 'undefined') {
        return;
      }
      this.isBusy = true;
      let url = "garantie/" + id;
      this.apiGet(url)
        .then(response => {
          this.insurance = response.data.quote;
          this.numberOfDuplicates = response.data.duplicates;
          this.isBusy = false;
        })
        .catch(error => {
          this.showErrorNotification(error);
          this.$router.push("/");
        });
    },
    parseValue(
      parsed_value,
      available_options,
      field_id = "ID",
      field_name = "NAME"
    ) {
      for (let value in available_options) {
        if (available_options[value][field_id] === +parsed_value)
          return available_options[value][field_name];
      }
      return "";
    },
    parseTypeCylinder(vehicle) {
      return this.list_type_cylinder[vehicle]
        ? this.list_type_cylinder[vehicle]
        : "";
    },
    parseCivility(civility) {
      switch (+civility) {
        case 0:
          return "Monsieur";
        case 1:
          return "Mademoiselle";
        case 2:
          return "Madame";
        case 3:
          return "Société";
        case 4:
          return "Monsieur et Madame";
        default:
          return "";
      }
    },

    parseCarBrand(brand) {
      return this.list_marque_auto[brand] ? this.list_marque_auto[brand] : "";
    },
    parseCirculationDate(details) {
      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? (day = "0" + day.toString()) : "";
      month.length < 2 ? (month = "0" + month.toString()) : "";

      let date = this.moment(new Date())
        .date(day)
        .month(month)
        .year(year);
      return date.format("DD/MM/YYYY");
    },
    parseSaleDate(quoteDatails) {
      if (quoteDatails.sale_date) {
        return this.moment(quoteDatails.sale_date).format("DD/MM/Y");
      }

      return "";
    },
    parseEffectiveDate(quoteDatails) {
      if (quoteDatails.effective_date) {
        return this.moment(quoteDatails.effective_date).format("DD/MM/Y");
      }

      return "";
    },
    parseDeliveryDate(quoteDatails) {
      if (quoteDatails.delivery_date) {
        return this.moment(quoteDatails.delivery_date).format("DD/MM/Y");
      }

      return "";
    },
    parseBirthDate(birthdate) {
      if (birthdate) {
        return this.moment(birthdate).format("DD/MM/Y");
      }

      return "";
    },
    parseAssistance(quoteDatails) {
      return +quoteDatails.assistance === 1 ? "Oui" : "Non";
    },
    parseCylinder(cylinder) {
      return this.list_cylinders_moto[cylinder]
        ? this.list_cylinders_moto[cylinder]
        : "";
    },
    getFrontPdf(stream = false) {
      this.refreshTokenForce()
        .then(response => {
          if (this.getDownloadLinkCopyPdf) {
            if (stream) {
              window.open(this.getDownloadLinkCopyPdf + '&show_type=stream', '_blank');
            } else {
              window.open(this.getDownloadLinkCopyPdf);
            }
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch(error => {
          this.showErrorNotification(error);
        });
    },
    getFrontPdfWL(stream = false) {
      this.refreshTokenForce()
        .then(response => {
          if (this.getDownloadLinkCopyPdfWL) {
            if (stream) {
              window.open(this.getDownloadLinkCopyPdfWL + '&show_type=stream', '_blank');
            } else {
              window.open(this.getDownloadLinkCopyPdfWL);
            }
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch(error => {
          this.showErrorNotification(error);
        });
    }
  },
  created() {
    if (this.insuranceData) {
      this.getQuoteInfo(this.insuranceData.id);
    } else if (this.$route.params.id) {
      this.getQuoteInfo(this.$route.params.id);
    }
  },
  mounted() {
    this.$eventBus.$emit("sidebar-set-active-tab", "Garantie Auto");

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch("backToDevisDisable");
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit("sidebar-set-active-tab", "");
  },
  watch: {
    pdfWindow: function () {
      window.location.href = "/garantie-auto-v2";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/auto/GarantieAutoView.vue